import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import {
    FormGroupType,
    NestedFormGroupType,
} from '../../../../../../../../../core/models/form-group-type';
import { AttachmentFormModel } from '../../../../../models/attachment/attachment-form-model';
import { AttachmentOperationFormModel } from '../../../../../models/attachment/attachment-operation-form-model';

@Injectable({
    providedIn: 'root',
})
export class AttachmentOperationFormService {
    getFormDefinition(): FormGroup<
        NestedFormGroupType<AttachmentOperationFormModel>
    > {
        return new FormGroup<NestedFormGroupType<AttachmentOperationFormModel>>(
            {
                attachments: new FormArray<
                    FormGroup<FormGroupType<AttachmentFormModel>>
                >([]),
            },
        );
    }

    /**
     * Retrieves the attachments form array from the provided form group.
     *
     * @param form The parent form group that contains the attachments form array.
     * @return FormArray of FormGroup representing the attachments.
     */
    getAttachments(
        form: FormGroup<NestedFormGroupType<AttachmentOperationFormModel>>,
    ): FormArray<FormGroup<NestedFormGroupType<AttachmentFormModel>>> {
        const attachments = form.controls.attachments as FormArray<
            FormGroup<NestedFormGroupType<AttachmentFormModel>>
        >;

        return attachments;
    }

    /**
     * Adds an attachment form to the beginning of the attachments form array.
     *
     * @param form The parent form group that contains the attachments form array.
     * @param attachmentForm The attachment form to add to the beginning of the array.
     */
    addAttachment(
        form: FormGroup<NestedFormGroupType<AttachmentOperationFormModel>>,
        attachmentForm: FormGroup<NestedFormGroupType<AttachmentFormModel>>,
    ): void {
        const attachments = form.controls.attachments as FormArray<
            FormGroup<NestedFormGroupType<AttachmentFormModel>>
        >;

        attachments.insert(0, attachmentForm);
        attachments.markAllAsTouched();
    }
}
